"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.positionText = positionText;
exports.positionDistanceFromZero = positionDistanceFromZero;
exports.positionSubtract = positionSubtract;
exports.positionAdd = positionAdd;
exports.positionIsZero = positionIsZero;
exports.positionWorldToTile = positionWorldToTile;
exports.positionTileToWorld = positionTileToWorld;
exports.positionWorldXYToTile = positionWorldXYToTile;
exports.positionSetXY = positionSetXY;
exports.positionSurrounding = positionSurrounding;
exports.positionInRange = positionInRange;
const interfaces_1 = require("@lotr/interfaces");
/**
 * Position in the format of `x y`
 */
function positionText(position) {
    return `${position.x} ${position.y}`;
}
/**
 * Number of tiles from `0 0`
 */
function positionDistanceFromZero(position) {
    return Math.max(Math.abs(position.x), Math.abs(position.y));
}
/**
 * Difference between this and the given position
 *
 * @returns position1 - position2
 */
function positionSubtract(position1, position2) {
    return { x: position1.x - position2.x, y: position1.y - position2.y };
}
/**
 * Add this and the given position
 *
 * @returns position1 + position2
 */
function positionAdd(position1, position2) {
    return { x: position1.x + position2.x, y: position1.y + position2.y };
}
/**
 * Checks if position is at zero
 */
function positionIsZero(position) {
    return position.x === 0 && position.y === 0;
}
/**
 * Converts a world position into a new tile position
 */
function positionWorldToTile(position) {
    return { x: Math.floor(position.x / 64), y: Math.floor(position.y / 64) };
}
/**
 * Converts a tile position into a new world position
 */
function positionTileToWorld(position) {
    return { x: position.x * 64 + 32, y: position.y * 64 + 32 };
}
/**
 * Converts a world position into a new tile position
 */
function positionWorldXYToTile({ worldX, worldY, }) {
    return positionWorldToTile({ x: worldX, y: worldY });
}
/**
 * Sets the receivers x, and y to position x, and y
 */
function positionSetXY(receiver, position) {
    receiver.x = position.x;
    receiver.y = position.y;
}
const surrounding = [
    { x: -1, y: -1, direction: interfaces_1.Direction.Northwest },
    { x: 0, y: -1, direction: interfaces_1.Direction.North },
    { x: 1, y: -1, direction: interfaces_1.Direction.Northeast },
    { x: -1, y: 0, direction: interfaces_1.Direction.West },
    { x: 1, y: 0, direction: interfaces_1.Direction.East },
    { x: -1, y: 1, direction: interfaces_1.Direction.Southwest },
    { x: 0, y: 1, direction: interfaces_1.Direction.South },
    { x: 1, y: 1, direction: interfaces_1.Direction.Southeast },
];
/**
 * Returns an array of each surrounding position
 */
function positionSurrounding() {
    return surrounding;
}
/**
 * Calls a method for each position in range of a given center
 *
 * @param center The center position
 * @param range The range around the position
 * @param method The method to call for each position in range
 */
function positionInRange(center, range, method) {
    for (let i = center.x - range; i <= center.x + range; i++) {
        for (let j = center.y - range; j <= center.y + range; j++) {
            method({ x: i, y: j });
        }
    }
}
